<template>
    <div>
        <div class="row d-flex justify-content-start ml-2 mb-2" v-if="!showList">
            <button class="btn btn-primary btn-sm" @click="showAgentsList()"><v-icon name="arrow-left" class="text-white font-weight-bold mr-2" style="width:14px;"></v-icon>Back</button>
        </div>
        <div class="overflow-auto " style="max-height: 580px; overflow-y: hidden;">
            <transition name="fade">
                <agents-list v-show="showList" @show-details="showAgent" ></agents-list>
            </transition>
            <transition name="fade" >
                <agent-show v-if="!showList" :agentId="agentId" @showList="showAgentsList()"></agent-show>
            </transition>
        </div>
    </div>
</template>

<script>
import AgentsList from './children/AgentsList'
import AgentShow from './children/AgentShow'

export default {
    name: 'DisplayAgents',
    components:{
        AgentsList,
        AgentShow
    },
    data() {
        return{
            selectedPage: 'AgentsList',
            agentId: null,
            showList: true,
        }
    },
    methods: {
        showAgent(agentId){
            this.agentId = agentId
            this.showList = false
        },
        showAgentsList(){
            console.log("I am here")
            this.showList = true
        }
    }
}
</script>
<style scoped>
    .fade-enter{
        opacity: 0;
    }
    .fade-enter-active{
        transition: opacity 0.5s;
    }
    .fade-leave-active{
        transition: opacity 0.5s;
        opacity: 0;
    }
</style>